// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.material-symbols-outlined {
  font-family: "Material Symbols Outlined";
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  font-variation-settings: "FILL" 0, "wght" 300, "GRAD" 0, "opsz" 24;
}

.toast-container {
  background: #fff;
  border: 1px solid #D5D7DA;
  box-shadow: 0 2px 2px -1px rgba(10, 13, 18, 0.0392156863), 0 4px 6px -2px rgba(10, 13, 18, 0.031372549), 0 12px 16px -4px rgba(10, 13, 18, 0.0784313725);
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.toast-container__left-slot {
  display: flex;
  align-items: center;
  gap: 10px;
}
.toast-container__left-slot--icon {
  display: grid;
  place-content: center;
}
.toast-container__left-slot--icon.success .outer-border {
  border: 2px solid #e7f5ee;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: grid;
  place-content: center;
}
.toast-container__left-slot--icon.success .outer-border .middle-border {
  border: 2px solid #b5dfcc;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: grid;
  place-content: center;
}
.toast-container__left-slot--icon.success .outer-border .middle-border .inner-border {
  border: 2px solid #079455;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: grid;
  place-content: center;
}
.toast-container__left-slot--icon.success .outer-border .middle-border .inner-border .material-symbols-outlined {
  color: #079455;
  font-size: 18px;
}
.toast-container__left-slot--icon.info .outer-border {
  border: 2px solid #e6f0fc;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: grid;
  place-content: center;
}
.toast-container__left-slot--icon.info .outer-border .middle-border {
  border: 2px solid #b3d1f7;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: grid;
  place-content: center;
}
.toast-container__left-slot--icon.info .outer-border .middle-border .inner-border {
  border: 2px solid #0066e4;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: grid;
  place-content: center;
}
.toast-container__left-slot--icon.info .outer-border .middle-border .inner-border .material-symbols-outlined {
  color: #0066e4;
  font-size: 18px;
}
.toast-container__left-slot--icon.danger .outer-border {
  border: 2px solid #fbeae9;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: grid;
  place-content: center;
}
.toast-container__left-slot--icon.danger .outer-border .middle-border {
  border: 2px solid #f4c0bd;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: grid;
  place-content: center;
}
.toast-container__left-slot--icon.danger .outer-border .middle-border .inner-border {
  border: 2px solid #d92d20;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: grid;
  place-content: center;
}
.toast-container__left-slot--icon.danger .outer-border .middle-border .inner-border .material-symbols-outlined {
  color: #d92d20;
  font-size: 18px;
}
.toast-container__left-slot--icon.warning .outer-border {
  border: 2px solid #fcf0e6;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: grid;
  place-content: center;
}
.toast-container__left-slot--icon.warning .outer-border .middle-border {
  border: 2px solid #f5d2b4;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: grid;
  place-content: center;
}
.toast-container__left-slot--icon.warning .outer-border .middle-border .inner-border {
  border: 2px solid #dc6803;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: grid;
  place-content: center;
}
.toast-container__left-slot--icon.warning .outer-border .middle-border .inner-border .material-symbols-outlined {
  color: #dc6803;
  font-size: 18px;
}
.toast-container__left-slot--title p {
  color: #181D27;
  font-weight: 600;
  font-size: 12px;
  white-space: pre-wrap;
  line-height: 20px;
  width: 200px;
  margin-bottom: 0px;
}
.toast-container__right-slot .toast-close {
  border: 0;
  background: transparent;
  padding: 4px;
  display: grid;
  place-items: center;
  cursor: pointer;
  border-radius: 4px;
}
.toast-container__right-slot .toast-close:focus-visible {
  outline: 2px solid #0066e4;
  outline-offset: 2px;
}
.toast-container__right-slot .material-symbols-outlined {
  color: #a4a7ae;
  cursor: pointer;
  font-size: 20px;
  transition: all 0.3s ease;
}
.toast-container__right-slot .material-symbols-outlined:hover {
  transform: scale(0.98);
}

@media (320px <= width <= 480px) {
  .toast-container__left-slot--title p {
    font-size: 11px;
    width: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/toast-msg/toast-msg.component.scss"],"names":[],"mappings":"AAEA;EACC,wCAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EAEA,kEACC;AAHF;;AASA;EACC,gBAAA;EACA,yBAAA;EACA,wJAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAND;AAQC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AANF;AAQE;EACC,aAAA;EACA,qBAAA;AANH;AAQI;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AANL;AAQK;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AANN;AAQM;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AANP;AAQO;EACC,cAAA;EACA,eAAA;AANR;AAcI;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AAZL;AAcK;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AAZN;AAcM;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AAZP;AAcO;EACC,cAAA;EACA,eAAA;AAZR;AAoBI;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AAlBL;AAoBK;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AAlBN;AAoBM;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AAlBP;AAoBO;EACC,cAAA;EACA,eAAA;AAlBR;AA0BI;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AAxBL;AA0BK;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AAxBN;AA0BM;EACC,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AAxBP;AA0BO;EACC,cAAA;EACA,eAAA;AAxBR;AAiCG;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AA/BJ;AAqCE;EACC,SAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAnCH;AAoCG;EAAkB,0BAAA;EAA4B,mBAAA;AAhCjD;AAkCE;EACC,cAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AAhCH;AAkCG;EACC,sBAAA;AAhCJ;;AAsCA;EACC;IACC,eAAA;IACA,YAAA;EAnCA;AACF","sourcesContent":["// Ported from customer-website's app-toast-msg.component.scss\n\n.material-symbols-outlined {\n\tfont-family: 'Material Symbols Outlined';\n\tfont-weight: normal;\n\tfont-style: normal;\n\tfont-size: 24px;\n\tline-height: 1;\n\tletter-spacing: normal;\n\ttext-transform: none;\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n\tword-wrap: normal;\n\tdirection: ltr;\n\n\tfont-variation-settings:\n\t\t'FILL' 0,\n\t\t'wght' 300,\n\t\t'GRAD' 0,\n\t\t'opsz' 24;\n}\n\n.toast-container {\n\tbackground: #fff;\n\tborder: 1px solid #D5D7DA;\n\tbox-shadow: 0 2px 2px -1px #0A0D120A, 0 4px 6px -2px #0A0D1208, 0 12px 16px -4px #0A0D1214;\n\tborder-radius: 12px;\n\tpadding: 12px 16px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\t&__left-slot {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\n\t\t&--icon {\n\t\t\tdisplay: grid;\n\t\t\tplace-content: center;\n\t\t\t&.success {\n\t\t\t\t& .outer-border {\n\t\t\t\t\tborder: 2px solid #e7f5ee;\n\t\t\t\t\twidth: 44px;\n\t\t\t\t\theight: 44px;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tdisplay: grid;\n\t\t\t\t\tplace-content: center;\n\n\t\t\t\t\t& .middle-border {\n\t\t\t\t\t\tborder: 2px solid #b5dfcc;\n\t\t\t\t\t\twidth: 32px;\n\t\t\t\t\t\theight: 32px;\n\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\tdisplay: grid;\n\t\t\t\t\t\tplace-content: center;\n\n\t\t\t\t\t\t& .inner-border {\n\t\t\t\t\t\t\tborder: 2px solid #079455;\n\t\t\t\t\t\t\twidth: 22px;\n\t\t\t\t\t\t\theight: 22px;\n\t\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\t\tdisplay: grid;\n\t\t\t\t\t\t\tplace-content: center;\n\n\t\t\t\t\t\t\t& .material-symbols-outlined {\n\t\t\t\t\t\t\t\tcolor: #079455;\n\t\t\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.info {\n\t\t\t\t& .outer-border {\n\t\t\t\t\tborder: 2px solid #e6f0fc;\n\t\t\t\t\twidth: 44px;\n\t\t\t\t\theight: 44px;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tdisplay: grid;\n\t\t\t\t\tplace-content: center;\n\n\t\t\t\t\t& .middle-border {\n\t\t\t\t\t\tborder: 2px solid #b3d1f7;\n\t\t\t\t\t\twidth: 32px;\n\t\t\t\t\t\theight: 32px;\n\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\tdisplay: grid;\n\t\t\t\t\t\tplace-content: center;\n\n\t\t\t\t\t\t& .inner-border {\n\t\t\t\t\t\t\tborder: 2px solid #0066e4;\n\t\t\t\t\t\t\twidth: 22px;\n\t\t\t\t\t\t\theight: 22px;\n\t\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\t\tdisplay: grid;\n\t\t\t\t\t\t\tplace-content: center;\n\n\t\t\t\t\t\t\t& .material-symbols-outlined {\n\t\t\t\t\t\t\t\tcolor: #0066e4;\n\t\t\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.danger {\n\t\t\t\t& .outer-border {\n\t\t\t\t\tborder: 2px solid #fbeae9;\n\t\t\t\t\twidth: 44px;\n\t\t\t\t\theight: 44px;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tdisplay: grid;\n\t\t\t\t\tplace-content: center;\n\n\t\t\t\t\t& .middle-border {\n\t\t\t\t\t\tborder: 2px solid #f4c0bd;\n\t\t\t\t\t\twidth: 32px;\n\t\t\t\t\t\theight: 32px;\n\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\tdisplay: grid;\n\t\t\t\t\t\tplace-content: center;\n\n\t\t\t\t\t\t& .inner-border {\n\t\t\t\t\t\t\tborder: 2px solid #d92d20;\n\t\t\t\t\t\t\twidth: 22px;\n\t\t\t\t\t\t\theight: 22px;\n\t\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\t\tdisplay: grid;\n\t\t\t\t\t\t\tplace-content: center;\n\n\t\t\t\t\t\t\t& .material-symbols-outlined {\n\t\t\t\t\t\t\t\tcolor: #d92d20;\n\t\t\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&.warning {\n\t\t\t\t& .outer-border {\n\t\t\t\t\tborder: 2px solid #fcf0e6;\n\t\t\t\t\twidth: 44px;\n\t\t\t\t\theight: 44px;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tdisplay: grid;\n\t\t\t\t\tplace-content: center;\n\n\t\t\t\t\t& .middle-border {\n\t\t\t\t\t\tborder: 2px solid #f5d2b4;\n\t\t\t\t\t\twidth: 32px;\n\t\t\t\t\t\theight: 32px;\n\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\tdisplay: grid;\n\t\t\t\t\t\tplace-content: center;\n\n\t\t\t\t\t\t& .inner-border {\n\t\t\t\t\t\t\tborder: 2px solid #dc6803;\n\t\t\t\t\t\t\twidth: 22px;\n\t\t\t\t\t\t\theight: 22px;\n\t\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\t\tdisplay: grid;\n\t\t\t\t\t\t\tplace-content: center;\n\n\t\t\t\t\t\t\t& .material-symbols-outlined {\n\t\t\t\t\t\t\t\tcolor: #dc6803;\n\t\t\t\t\t\t\t\tfont-size: 18px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&--title {\n\t\t\tp {\n\t\t\t\tcolor: #181D27;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 12px;\n\t\t\t\twhite-space: pre-wrap;\n\t\t\t\tline-height: 20px;\n\t\t\t\twidth: 200px;\n\t\t\t\tmargin-bottom: 0px;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__right-slot {\n\t\t.toast-close {\n\t\t\tborder: 0;\n\t\t\tbackground: transparent;\n\t\t\tpadding: 4px;\n\t\t\tdisplay: grid;\n\t\t\tplace-items: center;\n\t\t\tcursor: pointer;\n\t\t\tborder-radius: 4px;\n\t\t\t&:focus-visible { outline: 2px solid #0066e4; outline-offset: 2px; }\n\t\t}\n\t\t& .material-symbols-outlined {\n\t\t\tcolor: #a4a7ae;\n\t\t\tcursor: pointer;\n\t\t\tfont-size: 20px;\n\t\t\ttransition: all 0.3s ease;\n\n\t\t\t&:hover {\n\t\t\t\ttransform: scale(0.98);\n\t\t\t}\n\t\t}\n\t}\n}\n\n@media (320px <= width <= 480px) {\n\t.toast-container__left-slot--title p {\n\t\tfont-size: 11px;\n\t\twidth: 150px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
